<!-- Navbar Start -->
<!-- <nav class="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0"> -->
<!-- <a class="navbar-brand d-flex align-items-center px-4 px-lg-5">
      <img
        src=""
        alt="Logo"
        width="218"
        height="auto"
        routerLink="/"
        class="logo cursor-pointer" />
    </a>
    <button
      type="button"
      class="navbar-toggler me-4"
      data-bs-toggle="collapse"
      data-bs-target="#navbarCollapse">
      <span class="navbar-toggler-icon"></span>
    </button> -->

<!-- <div class="collapse navbar-collapse" id="navbarCollapse">
      <div class="navbar-nav ms-auto p-4 p-lg-0">
        <ng-container *ngFor="let item of menuService.menu">
          <ng-container *ngIf="!item.subitems; else tieneSubmenu">
            <a
              class="nav-item nav-link active text-center"
              [routerLink]="[item.url]"
              >{{ item.descripcion }}</a
            >
          </ng-container>
          <ng-template #tieneSubmenu>
            <div class="nav-item dropdown">
              <a
                href="#"
                class="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                >{{ item.descripcion }}</a
              >
              <div class="dropdown-menu fade-up m-0">
                <a
                  *ngFor="let subitem of item.subitems"
                  (click)="cargarFactura()"
                  class="dropdown-item"
                  >{{ subitem.descripcion }}</a
                >
              </div>
            </div>
          </ng-template>
        </ng-container>
        <a
          class="btn btn-primary py-4 px-lg-5 d-none d-lg-flex justify-content-center align-items-center f-14"
          (click)="cargarFactura()">
          <span class="d-flex justify-content-center align-items-center">
            Cargar Factura <i class="fa fa-arrow-right ms-3"></i>
          </span>
        </a>
      </div>
    </div> -->
<!-- </nav> -->
<!-- Navbar End -->

<nav
  class="navbar navbar-expand-lg bg-body-tertiary navbar-fixed p-0"
  style="background-color: #333F48 !important"
>
  <div class="container-fluid">
    <a class="navbar-brand d-flex align-items-center px-4 px-lg-5">
      <img
        src="../../../../assets/img/Fibrainn-Logotipo-01.png"
        alt="Logo"
        width="518"
        height="auto"
        routerLink="/"
        class="logo cursor-pointer"
      />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto p-4 p-lg-0">
        <li class="nav-item" *ngFor="let item of menuService.menu">
          <a
            class="nav-link"
            [routerLink]="[item.url]"
            [routerLinkActive]="'active'"
          >
            {{ item.descripcion }}</a
          >
        </li>
      </ul>
      <ul class="navbar-nav ms-auto p-4 p-lg-0">
        <li class="nav-item">
          <a
            class="btn btn-primary py-4 px-lg-5 d-none d-lg-flex justify-content-center align-items-center f-14"
            (click)="cargarFactura()"
          >
            <span class="d-flex justify-content-center align-items-center">
              Cargar Factura <i class="fa fa-arrow-right ms-3"></i>
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
